export default __webpack_public_path__ + "c97f35faf5c1d3bc049ee07a59befc06.jpg";